import React, { Component } from 'react'
import { Table, Divider, Form, message, Input, Modal, Col, Radio, Button, Row } from 'antd'
import './style.less'
import { studentList, putStudent } from '../../api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
const { TextArea } = Input

class studentCertification extends Component {
	state = {
		loading: false,
		visible: false,
		fileList: [],

		isLoading: true,

		params: {
			pageNum: 0,
			pageSize: 10,
		},
		pageData: {
			total: 0,
			current: 1,
		},
		list: [],
		total: 0,
		merchantCount: 0,
		userCount: 0,
		fail: 0,
		pend: 0,
		success: 0,
	}

	componentDidMount() {
		const { params } = this.state
		this.loadList(params)
	}

	loadList(params) {
		const hide = message.loading('加载中...', 0)
		this.setState({ isLoading: true })
		studentList(params)
			.then(res => {
				console.log(res)
				this.setState({
					list: res.data.content,
					isLoading: false,
					pageData: {
						current: res.data.pageable.pageNumber + 1,
						total: res.data.totalElements,
						pageSize: res.data.pageable.pageSize,
					},
				})
				hide()
			})
			.catch(err => {
				this.setState({
					list: [],
					isLoading: false,
					pageData: {
						current: 0,
						total: 0,
						pageSize: 0,
					},
				})
			})
	}


	showModal = (e) => {
		this.props.form.setFieldsValue({
			status: e.status === 0 ? null : e.status,
			reason: e.status === 2 ? e.reason : null
		});
		this.setState({
			visible: true,
			visibleData: e
		})
	}

	handleOk = () => {
		if (this.state.visibleData.status !== 0) {
			this.handleCancel()
			return false
		}
		const { validateFields } = this.props.form
		validateFields((err, values) => {
			if (err === null) {
				const hide = message.loading('加载中...', 0)
				this.setState({ loading: true })
				putStudent({
					id: this.state.visibleData.id,
					status: values.status,
					reason: values.status === 2 ? values.reason : null
				}).then(res => {
					this.loadList(this.state.params)
					hide()
					this.setState({ loading: false, visible: false, })
				}).catch(res => {
					hide()
					this.setState({ loading: false, visible: false })
				})

			}


		})


	}

	handleCancel = () => {
		this.props.form.setFieldsValue({
			status: 0
		});
		this.setState({ visible: false })
	}

	// 分页
	onPageChange = (e) => {
		if (this.state.isLoading) {
			return false
		}
		const { params } = this.state
		params.pageNum = e.current - 1
		this.loadList(params)
	}

	render() {
		const columns = [
			{
				title: '手机号',
				dataIndex: 'tel',
				key: 'tel',
			},
			{
				title: '学生姓名',
				dataIndex: 'realName',
				key: 'realName',
			},
			{
				title: '出生日期',
				dataIndex: 'dateBirth',
				key: 'dateBirth',
			},
			{
				title: '学校名称',
				dataIndex: 'schools',
				key: 'schools',
			},

			{
				title: '状态',
				render: e => {
					switch (e.status) {
						case 0:
							return '待审核'
						case 1:
							return '已通过'
						case 2:
							return '已拒绝'

					}
				},
				key: 'status',
			},
			{
				title: '操作员',
				render: e => {
					switch (e.operator) {
						case null:
							return '-'
						default:
							return e.operator

					}
				},
				key: 'operator',
			},


			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					<span>
						<Divider type="vertical" />
						<a href='javascript:' onClick={() => { this.showModal(text) }} >操作</a>
					</span>
				),
			},
		]
		const { visible, loading } = this.state
		const { getFieldDecorator, getFieldsValue } = this.props.form
		const { status } = getFieldsValue()
		return (
			<div className='studentCertification-page'>
				<PrevImg ref={el => this.PrevImg = el} />

				<div className='board'>
					<Row>
						<Button onClick={() => {
							this.setState({
								params: {
									pageNum: 0,
									pageSize: 10,
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>全部</Button>
						<Button onClick={() => {
							this.setState({
								params: {
									pageNum: 0,
									pageSize: 10,
									status: 0,
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>待审核</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									status: 1,
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>已通过</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									status: 2,
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>已拒绝</Button>

					</Row>
					<Row className='search-board'>
						<Col lg={{ span: 6 }} style={{ width: 260 }}>
							<span >手机号搜索：</span>
							<Input
								style={{ width: 165 }}
								value={this.state.mobile}
								onChange={(event) => {
									this.setState({ mobile: event.target.value })
								}}
								placeholder="手机号"
							/>
						</Col>

						<Col lg={{ span: 6 }} >
							<Button type='primary' onClick={() => {
								let param = {
									pageNum: 0,
									pageSize: 10,
								}
								if (this.state.mobile) {
									param['tel'] = this.state.mobile
								}
								this.setState({
									params: param
								}, this.loadList(param))
							}}
							>搜索</Button>
						</Col>

					</Row>
				</div>
				<div className='tablecontain'>

					<Table
						bordered
						columns={columns}
						dataSource={this.state.list}
						rowKey="id"
						pagination={{
							current: this.state.pageData.current,
							total: this.state.pageData.total,
							pageSize: this.state.pageData.pageSize,
						}}
						onChange={this.onPageChange}
					/>
				</div>
				<Modal
					visible={visible}
					title="认证信息"
					onOk={this.handleOk}
					onCancel={this.handleCancel}
					footer={[
						<Button key="back" onClick={this.handleCancel}>取消</Button>,
						<Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>确定</Button>,
					]}
				>
					<div><span style={{ color: '#999' }}>姓名 : </span><span>{this.state.visibleData && this.state.visibleData.realName}</span></div>
					<div><span style={{ color: '#999' }}>手机号码 : </span><span>{this.state.visibleData && this.state.visibleData.tel}</span></div>
					<div><span style={{ color: '#999' }}>出生日期 : </span><span>{this.state.visibleData && this.state.visibleData.dateBirth}</span></div>
					<div><span style={{ color: '#999' }}>身份证号 : </span><span>{this.state.visibleData && this.state.visibleData.idNumber}</span></div>
					<div><span style={{ color: '#999' }}>教育程度 : </span><span>{this.state.visibleData && this.state.visibleData.education}</span></div>
					<div><span style={{ color: '#999' }}>所属学校 : </span><span>{this.state.visibleData && this.state.visibleData.schools}</span></div>
					<div><span style={{ color: '#999' }}>详细地址 : </span><span>{this.state.visibleData && this.state.visibleData.region}</span></div>
					<div><span style={{ color: '#999' }}>身份证照片 :</span></div>
					<div style={{ marginLeft: 40, marginTop: 10 }}>
						<div style={{ width: 170, height: 120, float: 'left', }}>
							<img style={{ width: 170, height: 100, }} onClick={() => this.PrevImg.show(this.state.visibleData.idFront)} src={this.state.visibleData && this.state.visibleData.idFront} />
							<p style={{ textAlign: 'center', }}>正面</p>
						</div>
						<div style={{ width: 170, height: 120, float: 'left', marginLeft: 20 }}>
							<img style={{ width: 170, height: 100, float: 'left' }} onClick={() => this.PrevImg.show(this.state.visibleData.idReverse)} src={this.state.visibleData && this.state.visibleData.idReverse} />
							<p style={{ textAlign: 'center', }}>反面</p>
						</div>
					</div>
					<div style={{ clear: 'both' }}><span style={{ color: '#999' }}>学生证 :</span></div>
					<div style={{ marginLeft: 40, marginTop: 10 }}>
						<img style={{ width: 170, height: 100, }} onClick={() => this.PrevImg.show(this.state.visibleData.studentCard)} src={this.state.visibleData && this.state.visibleData.studentCard} />
					</div>

					<Form.Item label="审核状态" >
						{
							getFieldDecorator('status', {
								rules: [{ required: true, message: '审核状态不能为空' }],
								initialValue: this.state.visibleData && this.state.visibleData.status
							})(
								<Radio.Group disabled={this.state.visibleData && this.state.visibleData.status != 0}>
									<Radio value={1}>通过</Radio>
									<Radio value={2}>不通过</Radio>
								</Radio.Group>
							)
						}
					</Form.Item>
					{(this.state.visibleData && (status === 2 || this.state.visibleData.status === 2)) ? <Form.Item label="拒绝原因：" className='flex'>
						{getFieldDecorator('reason', {
							rules: [{
								required: true,
								message: '请输入拒绝原因',
							}],
							initialValue: this.state.visibleData && this.state.visibleData.reason ? this.state.visibleData.reason : '',
						})(
							<TextArea disabled={this.state.visibleData && this.state.visibleData.status != 0} placeholder="拒绝原因" />
						)}
					</Form.Item> : null}


				</Modal>
			</div>
		)
	}
}

export default Form.create({ name: 'post_data' })(studentCertification)